/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
import { pxToEm, replacePXinStringWithEM } from '@insticator/insticator-ui'; // iui-utils
import { url } from 'utils/urls';



/* ++++++++++ --------------- EXPORT : EMBED PLACEMENT : STYLES --------------- ++++++++++ */
export default theme => ({
	placement: {
		'& .placement-select': {
			display: 'flex',
			flexWrap: 'wrap',
			justifyContent: 'center',

			// item selected
			'&.selected': {
				'&-rail': {
					'& .rail': { border: replacePXinStringWithEM(`4px solid #1494F4`) }
				},
				'&-in-content': {
					'& .in-content': { border: replacePXinStringWithEM(`4px solid #1494F4`) }
				}
			},

			// location
			'& .placement-location': {
				background: theme.color.light.light.swatch,
				borderRadius: pxToEm(6),
				border: replacePXinStringWithEM(`1px solid #ECF0F7`),
				boxShadow: replacePXinStringWithEM('0 3px 4px 0 #EDF1FA'),
				cursor: 'pointer',
				padding: pxToEm(20),
				height: pxToEm(324),
				width: '48%',
				minWidth: pxToEm(294),
				maxWidth: pxToEm(544),
				margin: replacePXinStringWithEM('0 1%'),
				textAlign: 'left',

				// animation
				transition: 'all .2s linear 0s',
				opacity: '0',
                animationDuration: '.2s',
                animationFillMode: 'forwards',
                animationDelay: '.3s',

                // hover
                '&:hover': {
					boxShadow: replacePXinStringWithEM(`0 0 15px 0 rgba(0,0,0,0.15)`)
				},

                // name
                '& .name': {
                	color: theme.color.primary.medium.swatch,
                	marginBottom: pxToEm(20)
                },
                // visual
                '& .visual': {
                	background: theme.color.light.light.swatch,
					backgroundRepeat: 'no-repeat',
	            	backgroundPosition: '50%',
	            	backgroundSize: 'contain',
	            	margin: '0 auto',
                	width: '100%', //pxToEm(517),
                	height: pxToEm(247)
                },


				// rail placement
				'&.rail': {
					animationName: 'fadeInLeft',
					marginBottom: pxToEm(30),
					'& .visual': { backgroundImage: `url(${url.image}/illustration-rail-image.png)` }
				},

				// in-content
				'&.in-content': {
					animationName: 'fadeInRight',
	                '& .visual': { backgroundImage: `url(${url.image}/illustration-in-content-image.png)` }
				}

			}
		}
	}
});
